import request from '../../../helpers/request';

export const changeTransportEntry = async ({
  transportId,
  isEntryAllowed,
  addressId,
}) => {
  return request.put(
    `/HousingStock/transport/entry`,
    { transportId, isEntryAllowed, addressId },
    'При изменении статуса въезда произошла ошибка',
    null
  );
};
